import React from 'react';
import { HeartPulse, FlaskConical, Salad, ShieldCheck, Stethoscope, Activity } from 'lucide-react';

const items = [
  { label: 'Metabolic Health', icon: HeartPulse },
  { label: 'Hormone Balance', icon: FlaskConical },
  { label: 'Precision Nutrition', icon: Salad },
  { label: 'Preventative Care', icon: ShieldCheck },
  { label: 'Functional Medicine', icon: Stethoscope },
  { label: 'Longevity', icon: Activity },
];

const Marquee = () => {
  const list = [...items, ...items];
  return (
    <section className="py-6 border-y border-[rgba(31,58,46,0.08)] bg-[var(--brand-cream-2)] overflow-hidden">
      <div className="marquee-track flex gap-14 whitespace-nowrap w-max">
        {list.map((it, i) => {
          const Ic = it.icon;
          return (
            <div key={i} className="flex items-center gap-3 text-[var(--brand-green-2)]">
              <Ic size={18} strokeWidth={1.6} />
              <span className="text-sm uppercase tracking-[0.28em]">{it.label}</span>
              <span className="h-1 w-1 rounded-full bg-[var(--brand-gold)] ml-6" />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Marquee;
